var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { doc, getDoc, updateDoc, onSnapshot } from 'firebase/firestore';
import { getFirestore } from 'firebase/firestore';
import { isRestApiMode, apiClient } from './restApi';
export class UserService {
    constructor() {
        this.db = getFirestore();
    }
    static getInstance() {
        if (!UserService.instance) {
            UserService.instance = new UserService();
        }
        return UserService.instance;
    }
    getUserRef(userId) {
        return doc(this.db, 'users', userId);
    }
    getUserData(userId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (isRestApiMode()) {
                const auth = (yield import('../firebase')).auth;
                const currentUid = (_a = auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid;
                if (currentUid === userId) {
                    return apiClient.get('/v1/users/me');
                }
                return apiClient.get(`/v1/users/${userId}/profile`);
            }
            const userDocRef = this.getUserRef(userId);
            const userDocSnap = yield getDoc(userDocRef);
            if (userDocSnap.exists()) {
                return userDocSnap.data();
            }
            else {
                throw new Error('User not found');
            }
        });
    }
    updateUserData(userId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (isRestApiMode()) {
                yield apiClient.patch('/v1/users/me', data);
                return;
            }
            const userRef = this.getUserRef(userId);
            yield updateDoc(userRef, data);
        });
    }
    onUserDataChange(uid, callback) {
        // T211 REVERTED: onSnapshot stays for cross-client real-time updates
        // (chat unread counters, profile changes from other tabs).
        // Accepted Google dependency per FR-029 — same compromise as chat messages.
        return onSnapshot(this.getUserRef(uid), (docSnapshot) => {
            callback(docSnapshot.data());
        });
    }
}
export default UserService;
